class LibraryMediaLabelsController {
  constructor ($scope, BulkApplyService, MediaLabelService, ColorService) {
    'ngInject'

    this._BulkApplyService = BulkApplyService
    this._MediaLabelService = MediaLabelService
    this._ColorService = ColorService

    this.editingId = false
    this.isLabelsCollapsed = false
    this.newLabel = this._generatePlaceholderLabel()
    this.colors = this._ColorService.getColors()

    this.MediaLabels = MediaLabelService.getAll()
    const unsubscribe = MediaLabelService.subscribe(state => {
      this.MediaLabels = state.MediaLabels
    })

    $scope.$on('$destroy', unsubscribe)
  }

  _generatePlaceholderLabel () {
    return {
      name: '',
      color: this._ColorService.getRandomColor()
    }
  }

  toggleEdit (labelId) {
    if (this.editingId === labelId) {
      this.editingId = false
    } else {
      this.editingId = labelId
    }
  }

  saveLabel () {
    const mediaLabel = this.MediaLabels.find(mediaLabel => mediaLabel.id === this.editingId)
    this._MediaLabelService.update(mediaLabel)
      .then(() => {
        this.toggleEdit(this.editingId)
      })
  }

  createLabel () {
    this._MediaLabelService.create(this.newLabel)
      .then(() => this.resetNewLabel())
  }

  resetNewLabel () {
    this.newLabel = this._generatePlaceholderLabel()
  }

  deleteLabel (labelId) {
    if (confirm('This action deletes the label, are you sure?')) {
      this._MediaLabelService.delete(labelId)
    }
  }

  applyLabel (labelId) {
    const elementsToLabel = [];

    ['serviceannouncements', 'socialmediasources', 'filemedias']
      .forEach(namespace => {
        this._BulkApplyService
          .getSelectedElements(namespace)
          .forEach(mediaId => elementsToLabel.push({ namespace, mediaId, labelId }))
      })

    // Elements have been selected, add labels
    if (elementsToLabel.length > 0) {
      elementsToLabel.forEach(element =>
        this._MediaLabelService.addLabel(element.namespace, element.mediaId, element.labelId))
    }

    // Reset all bulk-select
    this._BulkApplyService.bulkSelectReset()
  }
}

export default {
  controller: LibraryMediaLabelsController,
  template: require('./library-media-labels.component.html').default
}
